module.exports = __webpack_public_path__ + "img/reward_bg.28015948.png";